import { AnyAction } from 'redux'

const moduleName = 'MMB/tooltip'

export enum TooltipActionType {
  SHOW_TOOLTIP = 'SHOW_TOOLTIP',
  HIDE_TOOLTIP = 'HIDE_TOOLTIP',
}
export enum TooltipModes {
  LABEL = 'LABEL',
  PIN = 'PIN',
}
export enum TooltipPositions {
  NORTH = 'north',
  EAST = 'east',
  SOUTH = 'south',
  WEST = 'west',
  CENTER = 'center',
}

const initialState = {
  visible: false,
  element: null,
  position: null,
  mode: null,
  text: '',
}
const defaultOptions = {
  mode: TooltipModes.LABEL,
  position: TooltipPositions.NORTH,
}

export default function reducer(state: TooltipState = initialState, action: AnyAction): TooltipState {
  switch (action.type) {
    case `${moduleName}/${TooltipActionType.SHOW_TOOLTIP}`:
      return {
        ...state,
        visible: true,
        element: action.element,
        position: action.position,
        mode: action.mode,
        text: action.text,
      }
    case `${moduleName}/${TooltipActionType.HIDE_TOOLTIP}`:
      return {
        ...state,
        visible: false,
      }
    default:
      return state
  }
}

export function showTooltipAction(text: string, element: HTMLElement, options: TooltipOptionsType = {}) {
  return (dispatch) => {
    const optionsWithDefaults = Object.assign(defaultOptions, options)
    dispatch({
      type: `${moduleName}/${TooltipActionType.SHOW_TOOLTIP}`,
      text,
      element,
      ...optionsWithDefaults,
    })
  }
}

export function hideTooltipAction() {
  return (dispatch) => {
    dispatch({
      type: `${moduleName}/${TooltipActionType.HIDE_TOOLTIP}`,
    })
  }
}

export type TooltipState = {
  visible: boolean,
  element: HTMLElement | null,
  position: TooltipPositions | null,
  mode: TooltipModes | null,
  text: React.ReactNode,
}

export type TooltipOptionsType = {
  closable?: boolean,
}